/**
 * Engagement models — how clients buy.
 *
 * Sourced from the cooperation models already listed in the site navigation,
 * plus the fixed-price milestone model referenced in the Rooted testimonial.
 *
 * The AI pilot leads deliberately: a fixed, time-boxed proof is how AI work
 * is usually bought, and it is a far smaller ask than an open-ended
 * engagement. It graduates into the three models below it.
 */
export const configEngagement = [
  {
    id: 'aiPilot',
    title: 'AI pilot',
    description:
      'A fixed four-to-six week engagement on one use case: build it, evaluate it against your real data, and give a clear recommendation either way.',
    bestFor: 'Proving whether AI earns its place before committing a roadmap.',
  },
  {
    id: 'dedicatedTeam',
    title: 'Dedicated team',
    description:
      'A cross-functional squad — engineers, designer, QA and a delivery lead — working only on your product, with the roadmap set by you.',
    bestFor: 'Funded products with a roadmap longer than six months.',
  },
  {
    id: 'staffAugmentation',
    title: 'Staff augmentation',
    description:
      'Senior specialists who join your existing team, in your tools and your rituals, to add capacity or a skill you are missing.',
    bestFor: 'In-house teams that need to move faster this quarter.',
  },
  {
    id: 'fixedPrice',
    title: 'Fixed-price milestones',
    description:
      'A defined scope broken into priced milestones, so you have cost certainty from the first day of the engagement.',
    bestFor: 'Well-specified builds, upgrades and integrations.',
  },
];
